// extracted by mini-css-extract-plugin
export default {"filter":"ItogsTabelForm_filter__5f9Pg","select":"ItogsTabelForm_select__nFwYU","button":"ItogsTabelForm_button__spnOo"};